import styled from "styled-components";

export const RoadmapWrapper = styled.div`
  color: #fff;
  margin-top: 80px;
`;

export const RoadmapContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

// Faq

export const FaqOutWrapper = styled.div`
  width: 100%;
  background: url("assets/faq.png") no-repeat;
  background-size: 100% 100%;
`;

export const FaqContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
`;
export const FaqWrapper = styled.div`
  margin-top: 32px;
`;
export const FaqTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  text-align: start;
  transition: all 0.3s;
  &:hover {
    color: #e11d48;
  }
  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
  }
`;

export const FaqContent = styled.div`
  font-weight: 400;
  font-size: 15px;
  line-height: 160%;
  margin-top: 30px;
  color: #ffffff;
  text-align: start;
  transition: all 0.3s;
`;
export const FaqItemContainer = styled.div`
  padding: 30px 0;
  cursor: pointer;
  border-bottom: 1px solid #bbbbbb;
`;
export const FaqDisplayContainer = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 50px;
  color: #ffffff;
  text-align: center;
`;

export const MemberShipWrapper = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
`;

export const MemberShipOutWrapper = styled.div`
  width: 100%;
  background: url("assets/membership.png") no-repeat;
  background-size: 100% 100%;
`;

export const MemberShipsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 160px;
  margin-top: 160px;
  @media screen and (max-width: 1250px) {
    max-width: 95%;
  }
  @media screen and (max-width: 1140px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
  }
  @media screen and (max-width: 780px) {
    margin-top: 40px;
    margin-bottom: 40px;
  }
`;
export const MemberShipCard = styled.div`
  max-width: 320px;
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(187, 48, 79, 0.1) 0%,
    rgba(225, 29, 72, 0.1) 100%
  );
  border: 1px solid #e11d48;
  border-radius: 31px;
  padding: 40px 16px 130px;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: rgba(225, 29, 72, 0.25) 0px 10px 20px,
      rgba(225, 29, 72, 0.25) 0px 6px 6px;
  }
`;
export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #ffffff;
  line-height: 40px;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  margin-bottom: 60px;
  span {
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.5px;
    b {
      font-size: 32px;
    }
  }
  div {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
    img {
      margin-right: 10px;
    }
  }
`;

export const CardContent = styled.div``;
export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 20px;
  div {
    display: flex;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    text-align: start;
    color: #ffffff;
    svg {
      min-height: 20px;
      min-width: 20px;
      margin-right: 10px;
    }
  }
`;
